/* eslint-disable default-param-last */
// Action types
const SET_TABS_LIST = "spirit/utils/SET_TABS_LIST";
const SET_TABS_LIST_RETENTION = "spirit/utils/SET_TABS_LIST_RETENTION";

// InitialState
export const initialState = {
  tabsList: "1",
  tabsListRetention: "1",
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TABS_LIST:
      return {
        ...state,
        tabsList: action.info,
      };
    case SET_TABS_LIST_RETENTION:
      return {
        ...state,
        tabsListRetention: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const setTabsList = (info) => ({
  type: SET_TABS_LIST,
  info,
});

export const setTabsListRetention = (info) => ({
  type: SET_TABS_LIST_RETENTION,
  info,
});
